// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay__22VYh","avatarContainer":"avatarContainer__26POa","headline":"headline__CEJzn","alignCenter":"alignCenter__26719"};